import styled from 'styled-components';
import { Tooltip } from 'antd';
import { UnderlineLink } from '../../commonStyles';

export const Receipt = styled.div`
  box-shadow: 0 9px 21px 0 rgba(128, 152, 213, 0.08);
  background-color: ${(props) => props.theme.backgroundColor.cardDark};
  padding: 20px 20px 15px 20px;
  width: 244.5px;
  height: 120px;
  display: inline-block;
  margin-right: 20px;
  overflow: hidden;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin-bottom: 10px;
    display: block;
    width: 98%;
    margin-right: 0;
  }
`;

export const DataHolder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ReceiptDate = styled.div`
  font-size: ${(props) => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.colors.disabled};
  margin: 0;
`;

export const ReceiptTag = styled.p`
  visibility: hidden;
  padding: 3px 10px;
  border: 1px solid ${(props) => props.theme.border.teal};
  color: ${(props) => props.theme.fontColors.primary};
  font-size: ${(props) => props.theme.fontSize.quaternary};
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  margin: 0;
  line-height: normal;
`;

export const ReceiptNo = styled.p`
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  color: ${(props) => props.theme.fontColors.headingColor};
  margin: 5px 0;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-family: ${(props) => props.theme.fontFamily.helveticaNeueBold};
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
`;

export const ReceiptActions = styled.div`
  margin-top: 5px;
`;

export const ReceiptAction = styled(UnderlineLink)`
  color: ${(props) => props.theme.colors.primaryColor};
  font-size: ${(props) => props.theme.fontSize.primary};
  line-height: ${(props) => props.theme.lineHeight.primary};
  text-decoration: underline;
  margin-left: ${(props) => (props.lMargin ? '20px' : '0px')};
  font-family: ${(props) => props.theme.fontFamily.helveticaNeue};
  &:hover {
    text-decoration: underline;
    color: ${(props) => props.theme.colors.primaryColor};
  }
  @media only screen and (max-width: 991px) {
    font-size: ${(props) => props.theme.fontSize.primary};
  }
`;

export const TooltipContainer = styled(Tooltip)`
  .contribution .ant-tooltip {
    top: 1853px !important;
  }
  position: relative;
  left: 0;
  display: inline-block;
`;
